<template>
  <div>
    <form @submit.prevent="clickSearch('activity')">
      <ButtonOpenToolModal />
      <InputSearchTerm />
      <InputDates />
      <InputWebsites />
      <FatButton width='100%'>
        {{ $t("setting.button.activity") }}
      </FatButton>
    </form>
  </div>
</template>

<script>
import ButtonOpenToolModal from '@/components/input/tool-picker/ButtonOpenToolModal'
import { createNamespacedHelpers } from 'vuex'
import InputSearchTerm from '@/components/input/InputSearchTerm'
import InputDates from '@/components/input/InputDates'
import InputWebsites from '@/components/input/InputWebsites'
import FatButton from '@/components/input/FatButton'
const { mapActions } = createNamespacedHelpers('searchSettings')

export default {
  components: {
    ButtonOpenToolModal,
    InputSearchTerm,
    InputDates,
    InputWebsites,
    FatButton
  },
  methods: {
    ...mapActions(['clickSearch'])
  }
}
</script>

<style scoped lang="scss">
form > * {
  margin-top: var(--spacing-5);
  font-family: var(--primary-font);
}
</style>
